import { useState, useEffect } from 'react';
import { useAuthStore } from '../store/useAuthStore';

interface FeatureFlags {
    workpad: boolean;
    inputModeSwitcherEnabled: boolean;
    cloudSttEnabled: boolean;
    retainAudioDefault: boolean;
}

export function useFeatureFlags(): FeatureFlags {
    const serverUrl = useAuthStore((state) => state.serverUrl);
    const _deviceToken = useAuthStore((state) => state.deviceToken);
    const [flags, setFlags] = useState<FeatureFlags>({
        workpad: true,
        inputModeSwitcherEnabled: false,
        cloudSttEnabled: false,
        retainAudioDefault: false,
    });

    useEffect(() => {
        if (!serverUrl) return;

        fetch(`${serverUrl}/api/features`)
            .then((res) => res.json())
            .then((data) => {
                if (data && typeof data.workpad === 'boolean') {
                    setFlags({
                        workpad: data.workpad,
                        inputModeSwitcherEnabled: !!data.inputModeSwitcherEnabled,
                        cloudSttEnabled: !!data.cloudSttEnabled,
                        retainAudioDefault: !!data.retainAudioDefault,
                    });
                }
            })
            .catch(() => {
                // On network failure, keep defaults
            });
    }, [serverUrl]);

    return flags;
}
